import { useKLModal as useKelanModal } from '@kelan-ui/vue'

export function useKLModal(): ReturnType<typeof useKelanModal> {
  const modal = useKelanModal()

  return {
    create: options => modal.create({ alignCenter: true, ...options }),
    info: options => modal.info({ alignCenter: true, ...options }),
    success: options => modal.success({ alignCenter: true, ...options }),
    warning: options => modal.warning({ alignCenter: true, ...options }),
    error: options => modal.error({ alignCenter: true, ...options }),
    confirm: options => modal.confirm({ alignCenter: true, ...options }),
  }
}
